import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {API_ROUTES, BASE_URL} from "../../core/constants/api.const";
import {BehaviorSubject, Observable} from "rxjs";
import {ApiRoutesModel} from "../../core/models/apiRoutesModel";
import {UserDTO} from "../models/userDTO";
import { SocialAuthService } from '@abacritt/angularx-social-login';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  userSubject: BehaviorSubject<UserDTO> = new BehaviorSubject<UserDTO>(new Object() as UserDTO);
  constructor(private http: HttpClient,
    @Inject(BASE_URL) private readonly baseURL: string,
              @Inject(API_ROUTES) private readonly apiRoutes: ApiRoutesModel) {
  }

  socialLogin(body: UserDTO): Observable<any> {
    let url = `${this.baseURL}/${this.apiRoutes.auth.socialLogin}`;
    return this.http.post<any>(url, body);
  }

  socialSignup(body: UserDTO): Observable<any> {
    let url = `${this.baseURL}/${this.apiRoutes.auth.socialSignup}`;
    return this.http.post<any>(url, body);
  }

  logout(body: UserDTO) {
    let url = `${this.baseURL}/${this.apiRoutes.auth.logout}`;
    return this.http.get<any>(url);
  }
}
